"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var PathLayer_1 = require("./PathLayer");
var Path = function (_a) {
    var coords = _a.coords, color = _a.color, width = _a.width, criterion = _a.criterion, dynamicRoute = _a.dynamicRoute;
    var pathLayer = react_1.useContext(PathLayer_1.PathLayerContext);
    var points = coords.map(function (p) { return window.SMap.Coords.fromWGS84(p.lng, p.lat); });
    var options = {
        color: color,
        width: width,
    };
    var getDynamicPath = function (results) {
        var newPoints = results && results.getResults().geometry;
        var polyline = new window.SMap.Geometry(window.SMap.GEOMETRY_POLYLINE, null, newPoints, options);
        pathLayer === null || pathLayer === void 0 ? void 0 : pathLayer.addGeometry(polyline);
    };
    if (dynamicRoute) {
        new window.SMap.Route(points, getDynamicPath, { criterion: criterion });
    }
    else {
        var polyline = new window.SMap.Geometry(window.SMap.GEOMETRY_POLYLINE, null, points, options);
        pathLayer === null || pathLayer === void 0 ? void 0 : pathLayer.addGeometry(polyline);
    }
    return null;
};
Path.defaultProps = {
    color: '#f00',
    width: 3,
    criterion: 'fast',
    dynamicRoute: false
};
exports.default = Path;
//# sourceMappingURL=Path.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-mapycz/lib/Path.js
// module id = 596
// module chunks = 0